import { I18n } from '@calendly/i18n'

export const getSummary = (status) => {
  if (status === 'locked') {
    return I18n.t('publisher.event_type_editor.sections.scheduling_settings.additional_options.timezone.locked')
  }

  return I18n.t('publisher.event_type_editor.sections.scheduling_settings.additional_options.timezone.use_invitees')
}
